import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import "./login-page.css";
import { Button, Spinner, useToast } from "@repo/ui";
import { useMinimumLoading } from "~/hooks/use-min-loading";

const ERROR_DELAY = 600;

export const LoginPage = () => {
  const auth = useAuth();
  const { showToast } = useToast();
  const isLoading = useMinimumLoading(auth.isLoading ?? false, ERROR_DELAY);

  useEffect(() => {
    if (auth.error) {
      const timeout = setTimeout(() => {
        showToast("error", auth?.error?.message || "Login failed", "Authentication Error");
      }, ERROR_DELAY);
      return () => clearTimeout(timeout);
    }
  }, [auth.error, showToast]);

  const handleSignIn = () => {
    auth.signinRedirect();
  };

  return (
    <div className="flex h-screen w-screen max-lg:flex-col">
      <div className="relative flex-1 items-center justify-center">
        <div className="flex flex-col items-center gap-[32rem] p-10 max-lg:gap-52 max-md:gap-64">
          <div className="mb-auto">
            <div className="login-color mt-15 text-6xl font-extrabold -tracking-wider max-lg:mt-0 max-lg:text-5xl">
              <span>G</span>
              <span className="relative -top-2 text-5xl">x</span>
              <span>E</span>
            </div>
          </div>
          <Button
            className="sign-in-button w-2xs py-9 text-2xl font-semibold max-md:px-15 max-md:py-4 max-md:text-xl"
            size={"lg"}
            justify="center"
            disabled={isLoading}
            onClick={handleSignIn}
          >
            {isLoading ? (
              <>
                <Spinner className="mr-2" />
                Signing in...
              </>
            ) : (
              "Sign in"
            )}
          </Button>
        </div>
      </div>

      <div className="right-section relative flex flex-1 items-center justify-center overflow-hidden">
        <div className="z-[2] max-w-2xl p-16 text-center text-white">
          <div className="mb-18 text-lg tracking-wide opacity-95">GXE Workflow</div>
          <h1 className="mb-20 text-8xl leading-1 font-bold max-lg:text-6xl max-md:text-5xl">
            Welcome!
          </h1>
          <p className="text-xl leading-7 font-light opacity-95 max-md:text-lg">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. In dui justo, cursus in nisi
            sit amet, interdum laoreet erat. Duis fringilla faucibus mi tristique convallis.
          </p>
        </div>
        <div className="circular-pattern"></div>
      </div>
    </div>
  );
};
